import React from 'react';
import he from 'he';
import { Button, ExternalLink, FontIcon, HoverAnimation, UI } from '@gik/ui';
import bemBlock from '@gik/core/utils/bemBlock';

export interface IItem {
  link: string;
  title: string;
  thumbnail: string;
  removeItem: () => Promise<void>;
  name: 'article' | 'product';
}

export interface ISavedItemCardProps {
  item: IItem;
}

const blockName = 'saved-item-card';

export default function SavedItemCard({ item }: ISavedItemCardProps) {
  const bem = bemBlock(blockName);

  // TODO:  use Decoder component instead (find usages of he.decode and replace everywhere)
  const decodedTitle = he.decode(item.title);

  const onClickRemove = async function (e: React.MouseEvent) {
    e.preventDefault();
    e.stopPropagation();

    const response = await UI.confirm(`Are you sure you want to remove this ${name} from your favorites?`);

    if (response) {
      await item.removeItem();
    }
  };

  return (
    <HoverAnimation className={bem('hover-wrapper')}>
      <ExternalLink className={bem()} href={item.link}>
        <section className={bem('picture')}>
          <img alt="thumbnail" src={item.thumbnail} />
        </section>

        <section className={bem('title')}>
          {decodedTitle.length > 68 ? decodedTitle.substr(0, 65) + '...' : decodedTitle}
        </section>

        <section className={bem('remove-button')}>
          <Button
            type="button"
            variant="primary-plain"
            size="sm"
            circle
            onClick={onClickRemove}
            tooltip={`Remove ${item.name}`}
          >
            <FontIcon name="close" />
          </Button>
        </section>
      </ExternalLink>
    </HoverAnimation>
  );
}
